module.exports = __webpack_public_path__ + "img/banner-TV-4__md.fcb4ad8a.jpg";